module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/title_fair-79c37008422f512c42ad0b1a95639af7.svg";